// Hand-drawn pest illustrations — friendly, recognizable, colored fills.

function MouseSvg(p = {}) {
  return (
    <svg viewBox="0 0 100 100" {...p}>
      <path d="M72 76 Q92 88 94 72 Q96 58 80 56" stroke="#BBBBC0" strokeWidth="5" fill="none" strokeLinecap="round"/>
      <ellipse cx="52" cy="72" rx="32" ry="22" fill="#AAAAAA"/>
      <circle cx="28" cy="62" r="20" fill="#AAAAAA"/>
      <circle cx="18" cy="42" r="12" fill="#D0D0D0"/>
      <circle cx="18" cy="42" r="7" fill="#FFBBBB"/>
      <circle cx="36" cy="38" r="12" fill="#D0D0D0"/>
      <circle cx="36" cy="38" r="7" fill="#FFBBBB"/>
      <circle cx="22" cy="58" r="5" fill="#222"/>
      <circle cx="24" cy="56" r="2" fill="white"/>
      <ellipse cx="12" cy="66" rx="5" ry="3.5" fill="#FF9999"/>
      <line x1="12" y1="63" x2="-2" y2="59" stroke="#999" strokeWidth="1.5"/>
      <line x1="12" y1="66" x2="-2" y2="66" stroke="#999" strokeWidth="1.5"/>
      <line x1="12" y1="69" x2="-2" y2="73" stroke="#999" strokeWidth="1.5"/>
      <ellipse cx="36" cy="93" rx="9" ry="5" fill="#BBBBBB"/>
      <ellipse cx="62" cy="93" rx="9" ry="5" fill="#BBBBBB"/>
    </svg>
  );
}

function RatSvg(p = {}) {
  return (
    <svg viewBox="0 0 100 100" {...p}>
      <path d="M80 70 Q100 82 102 66 Q104 50 88 50" stroke="#AA8866" strokeWidth="5" fill="none" strokeLinecap="round"/>
      <ellipse cx="52" cy="72" rx="36" ry="24" fill="#AA8866"/>
      <ellipse cx="22" cy="60" rx="20" ry="17" fill="#AA8866"/>
      <ellipse cx="6" cy="63" rx="12" ry="8" fill="#CC9966"/>
      <circle cx="24" cy="45" r="9" fill="#CC9966"/>
      <circle cx="24" cy="45" r="5" fill="#FFBBAA"/>
      <circle cx="18" cy="57" r="5" fill="#111"/>
      <circle cx="20" cy="55" r="2" fill="white"/>
      <circle cx="2" cy="63" r="4" fill="#FF6666"/>
      <line x1="6" y1="61" x2="-6" y2="57" stroke="#888" strokeWidth="1.5"/>
      <line x1="6" y1="63" x2="-6" y2="63" stroke="#888" strokeWidth="1.5"/>
      <line x1="6" y1="65" x2="-6" y2="69" stroke="#888" strokeWidth="1.5"/>
      <ellipse cx="36" cy="93" rx="9" ry="5" fill="#996644"/>
      <ellipse cx="62" cy="93" rx="9" ry="5" fill="#996644"/>
    </svg>
  );
}

function WaspSvg(p = {}) {
  return (
    <svg viewBox="0 0 100 100" {...p}>
      {/* wings */}
      <ellipse cx="36" cy="36" rx="28" ry="11" fill="rgba(190,215,255,0.85)" transform="rotate(-25 36 36)"/>
      <ellipse cx="64" cy="36" rx="28" ry="11" fill="rgba(190,215,255,0.85)" transform="rotate(25 64 36)"/>
      {/* stinger */}
      <polygon points="50,98 45,85 55,85" fill="#555"/>
      {/* body */}
      <ellipse cx="50" cy="76" rx="17" ry="20" fill="#FFD700"/>
      <rect x="33" y="69" width="34" height="5" rx="2" fill="#333"/>
      <rect x="33" y="80" width="34" height="5" rx="2" fill="#333"/>
      {/* thorax */}
      <ellipse cx="50" cy="55" rx="13" ry="10" fill="#333"/>
      {/* head */}
      <circle cx="50" cy="38" r="13" fill="#FFD700"/>
      <circle cx="43" cy="36" r="6" fill="#222"/>
      <circle cx="57" cy="36" r="6" fill="#222"/>
      <circle cx="45" cy="34" r="2" fill="white"/>
      <circle cx="59" cy="34" r="2" fill="white"/>
      {/* antennae */}
      <path d="M44 26 Q37 15 31 11" stroke="#333" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <circle cx="31" cy="11" r="4" fill="#333"/>
      <path d="M56 26 Q63 15 69 11" stroke="#333" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <circle cx="69" cy="11" r="4" fill="#333"/>
    </svg>
  );
}

function BedbugSvg(p = {}) {
  return (
    <svg viewBox="0 0 100 100" {...p}>
      {/* legs */}
      <line x1="36" y1="50" x2="14" y2="37" stroke="#8B3A1A" strokeWidth="3" strokeLinecap="round"/>
      <line x1="34" y1="60" x2="10" y2="60" stroke="#8B3A1A" strokeWidth="3" strokeLinecap="round"/>
      <line x1="36" y1="70" x2="14" y2="83" stroke="#8B3A1A" strokeWidth="3" strokeLinecap="round"/>
      <line x1="64" y1="50" x2="86" y2="37" stroke="#8B3A1A" strokeWidth="3" strokeLinecap="round"/>
      <line x1="66" y1="60" x2="90" y2="60" stroke="#8B3A1A" strokeWidth="3" strokeLinecap="round"/>
      <line x1="64" y1="70" x2="86" y2="83" stroke="#8B3A1A" strokeWidth="3" strokeLinecap="round"/>
      {/* body */}
      <ellipse cx="50" cy="60" rx="24" ry="18" fill="#8B4513"/>
      <ellipse cx="50" cy="60" rx="19" ry="14" fill="#A0522D"/>
      {/* head */}
      <ellipse cx="50" cy="43" rx="13" ry="9" fill="#8B4513"/>
      <circle cx="44" cy="41" r="4" fill="#CC0000"/>
      <circle cx="56" cy="41" r="4" fill="#CC0000"/>
      <circle cx="45" cy="40" r="1.5" fill="white"/>
      <circle cx="57" cy="40" r="1.5" fill="white"/>
      {/* antennae */}
      <path d="M44 36 Q38 28 32 24" stroke="#5D3010" strokeWidth="2" fill="none" strokeLinecap="round"/>
      <path d="M56 36 Q62 28 68 24" stroke="#5D3010" strokeWidth="2" fill="none" strokeLinecap="round"/>
    </svg>
  );
}

function AntSvg(p = {}) {
  return (
    <svg viewBox="0 0 100 100" {...p}>
      {/* legs */}
      <line x1="42" y1="54" x2="22" y2="42" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="40" y1="63" x2="16" y2="63" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="42" y1="72" x2="22" y2="84" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="58" y1="54" x2="78" y2="42" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="60" y1="63" x2="84" y2="63" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="58" y1="72" x2="78" y2="84" stroke="#333" strokeWidth="2.5" strokeLinecap="round"/>
      {/* abdomen */}
      <ellipse cx="50" cy="80" rx="18" ry="22" fill="#CC3300"/>
      {/* thorax */}
      <ellipse cx="50" cy="62" rx="10" ry="8" fill="#333"/>
      {/* head */}
      <circle cx="50" cy="43" r="13" fill="#CC3300"/>
      <circle cx="44" cy="41" r="4" fill="#FFE000"/>
      <circle cx="56" cy="41" r="4" fill="#FFE000"/>
      <circle cx="45" cy="40" r="2" fill="#111"/>
      <circle cx="57" cy="40" r="2" fill="#111"/>
      {/* antennae */}
      <path d="M44 31 Q36 19 28 13" stroke="#333" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <circle cx="28" cy="13" r="4" fill="#333"/>
      <path d="M56 31 Q64 19 72 13" stroke="#333" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <circle cx="72" cy="13" r="4" fill="#333"/>
    </svg>
  );
}

function RoachSvg(p = {}) {
  return (
    <svg viewBox="0 0 100 100" {...p}>
      {/* wing covers */}
      <ellipse cx="42" cy="64" rx="20" ry="28" fill="#5D3A1A" transform="rotate(-5 42 64)"/>
      <ellipse cx="58" cy="64" rx="20" ry="28" fill="#5D3A1A" transform="rotate(5 58 64)"/>
      <ellipse cx="50" cy="64" rx="18" ry="26" fill="#8B5E3C"/>
      {/* legs */}
      <line x1="37" y1="52" x2="16" y2="40" stroke="#4A2F10" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="35" y1="64" x2="12" y2="64" stroke="#4A2F10" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="37" y1="76" x2="16" y2="88" stroke="#4A2F10" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="63" y1="52" x2="84" y2="40" stroke="#4A2F10" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="65" y1="64" x2="88" y2="64" stroke="#4A2F10" strokeWidth="2.5" strokeLinecap="round"/>
      <line x1="63" y1="76" x2="84" y2="88" stroke="#4A2F10" strokeWidth="2.5" strokeLinecap="round"/>
      {/* head */}
      <ellipse cx="50" cy="38" rx="15" ry="11" fill="#8B5E3C"/>
      <ellipse cx="50" cy="38" rx="11" ry="8" fill="#A0702A"/>
      <circle cx="43" cy="36" r="5" fill="#111"/>
      <circle cx="57" cy="36" r="5" fill="#111"/>
      <circle cx="44" cy="35" r="2" fill="#EEEE00"/>
      <circle cx="58" cy="35" r="2" fill="#EEEE00"/>
      {/* antennae */}
      <path d="M43 27 Q34 14 24 8" stroke="#4A2F10" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
      <path d="M57 27 Q66 14 76 8" stroke="#4A2F10" strokeWidth="2.5" fill="none" strokeLinecap="round"/>
    </svg>
  );
}

function FlySvg(p = {}) {
  return (
    <svg viewBox="0 0 100 100" {...p}>
      {/* wings */}
      <ellipse cx="28" cy="44" rx="22" ry="12" fill="rgba(190,215,255,0.7)" transform="rotate(-20 28 44)"/>
      <ellipse cx="72" cy="44" rx="22" ry="12" fill="rgba(190,215,255,0.7)" transform="rotate(20 72 44)"/>
      {/* body */}
      <ellipse cx="50" cy="68" rx="16" ry="22" fill="#2B2B2B"/>
      <ellipse cx="50" cy="64" rx="12" ry="16" fill="#4A4A4A"/>
      {/* head */}
      <circle cx="50" cy="40" r="14" fill="#3A3A3A"/>
      <ellipse cx="43" cy="38" rx="6" ry="8" fill="#CC2222"/>
      <ellipse cx="57" cy="38" rx="6" ry="8" fill="#CC2222"/>
      <circle cx="44" cy="36" r="2" fill="#FFAAAA"/>
      <circle cx="58" cy="36" r="2" fill="#FFAAAA"/>
      {/* legs */}
      <line x1="40" y1="60" x2="22" y2="56" stroke="#222" strokeWidth="2" strokeLinecap="round"/>
      <line x1="40" y1="68" x2="20" y2="72" stroke="#222" strokeWidth="2" strokeLinecap="round"/>
      <line x1="40" y1="76" x2="24" y2="88" stroke="#222" strokeWidth="2" strokeLinecap="round"/>
      <line x1="60" y1="60" x2="78" y2="56" stroke="#222" strokeWidth="2" strokeLinecap="round"/>
      <line x1="60" y1="68" x2="80" y2="72" stroke="#222" strokeWidth="2" strokeLinecap="round"/>
      <line x1="60" y1="76" x2="76" y2="88" stroke="#222" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );
}

function SpiderSvg(p = {}) {
  return (
    <svg viewBox="0 0 100 100" {...p}>
      {/* legs */}
      <path d="M38 50 Q22 30 14 24" stroke="#2A1810" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
      <path d="M38 56 Q18 48 8 48" stroke="#2A1810" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
      <path d="M38 62 Q18 70 10 78" stroke="#2A1810" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
      <path d="M38 68 Q26 84 22 92" stroke="#2A1810" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
      <path d="M62 50 Q78 30 86 24" stroke="#2A1810" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
      <path d="M62 56 Q82 48 92 48" stroke="#2A1810" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
      <path d="M62 62 Q82 70 90 78" stroke="#2A1810" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
      <path d="M62 68 Q74 84 78 92" stroke="#2A1810" strokeWidth="3.5" fill="none" strokeLinecap="round"/>
      {/* body */}
      <ellipse cx="50" cy="62" rx="18" ry="20" fill="#3A2418"/>
      <ellipse cx="50" cy="62" rx="13" ry="15" fill="#5A3528"/>
      {/* head */}
      <circle cx="50" cy="42" r="11" fill="#3A2418"/>
      <circle cx="44" cy="40" r="3" fill="#FFE000"/>
      <circle cx="56" cy="40" r="3" fill="#FFE000"/>
      <circle cx="46" cy="44" r="2" fill="#FFE000"/>
      <circle cx="54" cy="44" r="2" fill="#FFE000"/>
    </svg>
  );
}

// ── Mini silhouet-iconen per plaag voor het Diensten-dropdown menu ──
// Monochrome line-art (currentColor stroke), 20x20 viewBox. Gebruik op
// kleine schaal in de navigatie en lijsten. Inspiratie: beestjeskwijt
// dropdown — minimalistisch, geen kleur, herkenbaar silhouet.

const navIconBase = { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" };

export const PEST_NAV_ICONS = {
  bedwantsen: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <ellipse cx="12" cy="12" rx="6" ry="8"/>
      <path d="M12 4v16M8.5 7l-3-1M8.5 12l-3 0M8.5 17l-3 1M15.5 7l3-1M15.5 12l3 0M15.5 17l3 1"/>
      <circle cx="10" cy="9" r=".5" fill="currentColor"/><circle cx="14" cy="9" r=".5" fill="currentColor"/>
    </svg>
  ),
  houtworm: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <path d="M3 16c2-3 4-3 6 0s4 3 6 0 4-3 6 0"/>
      <circle cx="20.5" cy="14" r=".7" fill="currentColor"/>
      <path d="M3 19c2-3 4-3 6 0s4 3 6 0 4-3 6 0" opacity=".5"/>
    </svg>
  ),
  kakkerlakken: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <ellipse cx="12" cy="13" rx="5" ry="7"/>
      <path d="M10 6l-2-3M14 6l2-3"/>
      <path d="M7 11l-3-1M7 14l-4 0M7 17l-3 1M17 11l3-1M17 14l4 0M17 17l3 1"/>
    </svg>
  ),
  mieren: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      {/* Mier: kop + thorax + abdomen (3 segmenten), 6 poten, 2 antennes */}
      <circle cx="5" cy="12" r="1.7"/>
      <ellipse cx="10" cy="12" rx="1.8" ry="1.5"/>
      <ellipse cx="16" cy="12" rx="3" ry="2.4"/>
      <path d="M3.7 10.8l-1.5-2M3.7 13.2l-1.5 2"/>
      <path d="M8.5 11l-1-2M8.5 13l-1 2M10 10.5l0-2M10 13.5l0 2M11.5 11l1-2M11.5 13l1 2"/>
      <circle cx="4.3" cy="11.5" r=".3" fill="currentColor"/>
    </svg>
  ),
  mollen: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <path d="M4 17c0-4 3-7 8-7s8 3 8 7"/>
      <path d="M4 17h16"/>
      <path d="M14 11l3-3M16 11l4-2"/>
      <circle cx="15.5" cy="13" r=".5" fill="currentColor"/>
      <path d="M5.5 17v-2M8 17v-2M16 17v-2M18.5 17v-2"/>
    </svg>
  ),
  motten: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <path d="M12 6v12"/>
      <path d="M12 8c-3-3-7-2-8 1-1 3 2 5 4 5 2 0 4-1 4-3"/>
      <path d="M12 8c3-3 7-2 8 1 1 3-2 5-4 5-2 0-4-1-4-3"/>
      <path d="M11 5l-1-2M13 5l1-2"/>
    </svg>
  ),
  muizen: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <circle cx="11" cy="13" r="5"/>
      <circle cx="7.5" cy="9" r="2"/>
      <circle cx="14.5" cy="9" r="2"/>
      <circle cx="11.5" cy="13" r=".6" fill="currentColor"/>
      <path d="M16 14c3 0 5 2 6 4"/>
    </svg>
  ),
  papiervisjes: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      {/* Papiervisje: tapered ovaal lichaam, 2 antennes voor, 3 staart-bristles,
          duidelijke segmenten op het lichaam */}
      <path d="M5 12c2-2.2 9-2.2 13 0c-4 2.2-11 2.2-13 0z"/>
      <path d="M5 11.5l-2-1.5M5 12l-2.5 0M5 12.5l-2 1.5"/>
      <path d="M18 11.5l3-2M18 12l3 0M18 12.5l3 2"/>
      <path d="M8 10.6l0 2.8M11 10.4l0 3.2M14 10.6l0 2.8"/>
      <circle cx="6.5" cy="11.8" r=".3" fill="currentColor"/>
    </svg>
  ),
  ratten: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      {/* Rat: langwerpig lichaam, spitse snuit, kleine oren, lange kromme staart */}
      <path d="M3 14c0-2.5 2.5-4 6-4s7 1.5 7 4-3 4-7 4-6-1.5-6-4z"/>
      <path d="M3 14c-1.2 0-2 .4-2 1 0 .6.8 1 2 1"/>
      <circle cx="6.5" cy="11" r=".9"/>
      <circle cx="10" cy="10.3" r="1"/>
      <circle cx="2.8" cy="13.5" r=".35" fill="currentColor"/>
      <path d="M2.3 14.8l-.8.4"/>
      <path d="M16 14c2 0 4 .5 5.5 2 1 1 1.5 2.5 1.5 4"/>
    </svg>
  ),
  rioolvliegjes: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <ellipse cx="12" cy="14" rx="2" ry="3"/>
      <path d="M12 11c-3-1-6 0-7 3 2 0 5-1 7-2"/>
      <path d="M12 11c3-1 6 0 7 3-2 0-5-1-7-2"/>
      <path d="M11 8l-1-2M13 8l1-2"/>
    </svg>
  ),
  spinnen: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <circle cx="12" cy="12" r="3"/>
      <path d="M9 10L4 7M9 12L3 12M9 14L4 17M15 10l5-3M15 12l6 0M15 14l5 3"/>
      <path d="M11 9l-1-3M13 9l1-3"/>
    </svg>
  ),
  vliegen: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <ellipse cx="12" cy="13" rx="3" ry="4"/>
      <path d="M12 10c-4-2-8-1-9 2 2 1 6 0 9-1"/>
      <path d="M12 10c4-2 8-1 9 2-2 1-6 0-9-1"/>
      <path d="M11 7l-1-2M13 7l1-2"/>
      <circle cx="11" cy="12" r=".4" fill="currentColor"/>
      <circle cx="13" cy="12" r=".4" fill="currentColor"/>
    </svg>
  ),
  vlooien: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <ellipse cx="11" cy="13" rx="4" ry="5" transform="rotate(-15 11 13)"/>
      <path d="M14 11l3-3M14 14l4-1"/>
      <path d="M7 16l-3 3M8 14l-4-1M9 11l-3-3"/>
      <circle cx="10" cy="11" r=".5" fill="currentColor"/>
    </svg>
  ),
  wespen: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      <ellipse cx="12" cy="14" rx="3" ry="5"/>
      <path d="M9.5 12h5M9.5 15h5M9.5 18h5"/>
      <path d="M12 10c-4-3-9-2-9 1 2 1 6 0 9-1"/>
      <path d="M12 10c4-3 9-2 9 1-2 1-6 0-9-1"/>
      <path d="M11 6l-1-2M13 6l1-2"/>
    </svg>
  ),
  zilvervisjes: (p = {}) => (
    <svg {...navIconBase} width="20" height="20" {...p}>
      {/* Zilvervisje: smal tapered lichaam (visachtig), 2 antennes voor,
          3 staart-bristles, fijne segmenten op het lichaam (meer dan papiervisje) */}
      <path d="M4 12c2-1.6 11-1.6 14 0c-3 1.6-12 1.6-14 0z"/>
      <path d="M4 11.6l-2-1.6M4 12l-2.5 0M4 12.4l-2 1.6"/>
      <path d="M18 11.6l3-2M18 12l3 0M18 12.4l3 2"/>
      <path d="M7 10.9l0 2.2M9 10.7l0 2.6M11 10.7l0 2.6M13 10.7l0 2.6M15 10.9l0 2.2"/>
      <circle cx="5.5" cy="11.8" r=".3" fill="currentColor"/>
    </svg>
  ),
};

export const PEST_DRAWINGS = {
  muizen: MouseSvg,
  ratten: RatSvg,
  wespen: WaspSvg,
  bedwantsen: BedbugSvg,
  mieren: AntSvg,
  kakkerlakken: RoachSvg,
  vliegen: FlySvg,
  spinnen: SpiderSvg,
};

// PNG images take priority over SVG drawings when available.
// Add a slug here only when assets/{file}.png exists AND a CSS position rule
// `.p-{slug} .wink-eye` is set in styles.css.
// Geëxporteerd zodat andere componenten (zoals AndereDienstenCarousel)
// dezelfde mapping kunnen hergebruiken — single source of truth.
export const PEST_IMAGES = {
  muizen: "/assets/photo-muis.png",
  ratten: "/assets/photo-rat.png",
  wespen: "/assets/photo-wesp.png",
  bedwantsen: "/assets/photo-bedwants.png",
  vliegen: "/assets/photo-vlieg.png",
  spinnen: "/assets/photo-spin.png",
  kakkerlakken: "/assets/photo-kakkerlak.png",
  rioolvliegjes: "/assets/photo-rioolvliegje.png",
  zilvervisjes: "/assets/photo-zilvervisje.png",
  vlooien: "/assets/photo-vloo.png",
  papiervisjes: "/assets/photo-papiervisje.png",
  mieren: "/assets/photo-mier.png",
  // Toegevoegd 2026-05-24: nieuwe plagen motten, mollen, houtworm. Foto's
  // moeten in public/assets/photo-{slug}.png staan (PNG + WebP voor optimal).
  motten: "/assets/photo-motten.png",
  mollen: "/assets/photo-mol.png",
  houtworm: "/assets/photo-houtworm.png",
};

function IconMouseLucide(p = {}) {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M21 12c0 4-3 7-7 7H10a7 7 0 0 1 0-14h1.5"/>
      <path d="M14 5a3 3 0 1 0-3 3"/>
      <circle cx="14" cy="13" r="1" fill="currentColor"/>
      <path d="M21 12c1 0 1-2 0-2"/>
    </svg>
  );
}
function IconRatLucide(p = {}) {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M22 12c0 4-3 7-7 7H8a6 6 0 0 1 0-12h2"/>
      <path d="M13 4a3 3 0 1 0-3 3"/>
      <circle cx="13" cy="12" r="1" fill="currentColor"/>
      <path d="M22 12c2 0 2-3 0-3"/>
      <path d="M15 19c3 1 6 3 6 3"/>
    </svg>
  );
}
function IconZapLucide(p = {}) {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
    </svg>
  );
}
function IconBugLucide(p = {}) {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M8 2 L 8.5 5"/>
      <path d="M16 2 L 15.5 5"/>
      <path d="M8 14 L 4 12"/>
      <path d="M8 12 L 3 12"/>
      <path d="M8 10 L 4 8"/>
      <path d="M16 14 L 20 12"/>
      <path d="M16 12 L 21 12"/>
      <path d="M16 10 L 20 8"/>
      <rect x="8" y="6" width="8" height="14" rx="4"/>
      <path d="M12 6 V 20"/>
    </svg>
  );
}
function IconMoonLucide(p = {}) {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/>
    </svg>
  );
}
function IconLayersLucide(p = {}) {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polygon points="12 2 2 7 12 12 22 7 12 2"/>
      <polyline points="2 17 12 22 22 17"/>
      <polyline points="2 12 12 17 22 12"/>
    </svg>
  );
}

const PEST_LUCIDE = {
  muizen: IconMouseLucide,
  ratten: IconRatLucide,
  wespen: IconZapLucide,
  kakkerlakken: IconBugLucide,
  bedwantsen: IconMoonLucide,
  mieren: IconLayersLucide,
};

export function PestDrawing({ kind, size = 100, variant = "card" }) {
  // Cartoon PNGs everywhere (restored).
  const imgSrc = PEST_IMAGES[kind];
  const altMap = {
    muizen: "Echte muis komt uit gat in plint, muizenbestrijding ABC Ongediertebestrijding Zuid-Holland",
    ratten: "Echte rat onder schuur, rattenbestrijding ABC Ongediertebestrijding Zuid-Holland",
    wespen: "Wespennest verwijderen door ABC Ongediertebestrijding, echte hoornaar close-up",
    bedwantsen: "Bedwants op huid, bedwantsenbestrijding met hittebehandeling",
    mieren: "Mierenkolonie rond nestopening, mierenbestrijding met gel-aas",
    kakkerlakken: "Echte kakkerlak close-up, kakkerlakkenbestrijding HACCP-conform",
    rioolvliegjes: "Rioolvliegje (motmug) close-up, rioolvliegjesbestrijding ABC Ongediertebestrijding",
    zilvervisjes: "Zilvervisje close-up, zilvervisjes bestrijden, vocht-gerelateerd ongedierte",
    vlooien: "Vlooien in vacht onder vergrootglas, vlooienbestrijding voor huisdier en woning",
    papiervisjes: "Papiervisje close-up op witte ondergrond, papiervisjesbestrijding ABC Ongediertebestrijding",
    vliegen: "Echte vlieg close-up, vliegenoverlast bestrijden",
    spinnen: "Huisspin close-up, spinnenbestrijding binnen en buiten",
  };

  if (imgSrc) {
    const webpSrc = imgSrc.replace(/\.png$/, '.webp');
    return (
      <span className={`pest-img-wrap p-${kind}-img`} style={{ width: size, height: size, position: 'relative', display: 'inline-block' }}>
        <picture>
          <source srcSet={webpSrc} type="image/webp" />
          <img
            src={imgSrc}
            alt={altMap[kind] || `${kind} bestrijden, ABC Ongediertebestrijding`}
            width={size}
            height={size}
            style={{ width: size, height: size, objectFit: 'contain', display: 'block' }}
            className="pest-png"
            loading="lazy"
            decoding="async"
          />
        </picture>
      </span>
    );
  }
  // No cartoon yet → "foto volgt" placeholder. Used for newly added pests.
  const COMING_SOON_PESTS = [];
  if (COMING_SOON_PESTS.includes(kind) || !PEST_DRAWINGS[kind]) {
    return (
      <span
        className={`pest-img-placeholder p-${kind}-img`}
        style={{
          width: size, height: size,
          display: 'inline-flex', flexDirection: 'column',
          alignItems: 'center', justifyContent: 'center',
          background: 'linear-gradient(145deg, #F4F6F9 0%, #E6EAF0 100%)',
          border: '2px dashed #C2CAD6',
          borderRadius: 16,
          color: '#7B8794',
          fontSize: Math.max(11, size * 0.085),
          fontWeight: 600,
          letterSpacing: '.01em',
          textAlign: 'center',
          padding: 8,
          boxSizing: 'border-box',
          gap: 6,
        }}
        aria-label={`Foto van ${kind} volgt`}
      >
        <svg width={size * 0.32} height={size * 0.32} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <rect x="3" y="5" width="18" height="14" rx="2"/>
          <circle cx="8.5" cy="10.5" r="1.5"/>
          <path d="m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
        </svg>
        <span>Foto volgt</span>
      </span>
    );
  }
  const Svg = PEST_DRAWINGS[kind] || MouseSvg;
  return <Svg width={size} height={size} />;
}

// ── UI icons ────────────────────────────────────────
export function IconPhone(p = {}) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
    </svg>
  );
}
export function IconPin(p = {}) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z"/>
      <circle cx="12" cy="10" r="3"/>
    </svg>
  );
}
export function IconClock(p = {}) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <circle cx="12" cy="12" r="10"/>
      <polyline points="12 6 12 12 16 14"/>
    </svg>
  );
}
export function IconMail(p = {}) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <polyline points="22,6 12,13 2,6"/>
    </svg>
  );
}
export function IconCheck(p = {}) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  );
}
export function IconShield(p = {}) {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    </svg>
  );
}
export function IconBolt(p = {}) {
  return (
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" {...p}>
      <circle cx="16" cy="16" r="14" fill="currentColor" fillOpacity="0.12"/>
      <path d="M17.5 5 L9 17.5 H14.5 L13 27 L22 13.5 H16.5 L17.5 5 Z"
            fill="currentColor" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round"/>
    </svg>
  );
}
export function IconGraduation(p = {}) {
  return (
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" {...p}>
      <circle cx="16" cy="16" r="14" fill="currentColor" fillOpacity="0.12"/>
      <path d="M3.5 13.5 L16 8 L28.5 13.5 L16 19 Z" fill="currentColor" fillOpacity="0.85"/>
      <path d="M3.5 13.5 L16 8 L28.5 13.5 L16 19 Z" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
      <path d="M9 16.5 V20.5 C9 22 12 23.5 16 23.5 C20 23.5 23 22 23 20.5 V16.5"
            stroke="currentColor" strokeWidth="1.8" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      <line x1="28.5" y1="13.5" x2="28.5" y2="19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
      <circle cx="28.5" cy="20" r="1.3" fill="currentColor"/>
    </svg>
  );
}
export function IconWallet(p = {}) {
  return (
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" {...p}>
      <circle cx="16" cy="16" r="14" fill="currentColor" fillOpacity="0.12"/>
      <rect x="6" y="10" width="20" height="14" rx="2.5"
            fill="currentColor" fillOpacity="0.85"
            stroke="currentColor" strokeWidth="1.3"/>
      <path d="M6 13 V9 C6 7.9 6.9 7 8 7 H21 V10"
            stroke="currentColor" strokeWidth="1.6" fill="none" strokeLinecap="round"/>
      <circle cx="22" cy="17" r="1.6" fill="white"/>
    </svg>
  );
}
export function IconBuilding(p = {}) {
  return (
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" {...p}>
      <circle cx="16" cy="16" r="14" fill="currentColor" fillOpacity="0.12"/>
      <rect x="5" y="13" width="9" height="14" rx="1"
            fill="currentColor" fillOpacity="0.7"
            stroke="currentColor" strokeWidth="1.3"/>
      <rect x="14" y="6" width="13" height="21" rx="1"
            fill="currentColor" fillOpacity="0.95"
            stroke="currentColor" strokeWidth="1.3"/>
      <rect x="7.5" y="16" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="10.5" y="16" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="7.5" y="20" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="10.5" y="20" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="17" y="9" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="20" y="9" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="23" y="9" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="17" y="13" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="20" y="13" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="23" y="13" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="17" y="17" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="20" y="17" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="23" y="17" width="1.8" height="1.8" fill="white" rx=".3"/>
      <rect x="19" y="22" width="3" height="5" fill="white" rx=".4"/>
    </svg>
  );
}
export function IconLeaf(p = {}) {
  return (
    <svg width="28" height="28" viewBox="0 0 32 32" fill="none" {...p}>
      <circle cx="16" cy="16" r="14" fill="currentColor" fillOpacity="0.12"/>
      <path d="M24 6 C18 6 8 8 6.5 18 C6 21 7 24.5 10 26 C15 22.5 21 18 24 6 Z"
            fill="currentColor" fillOpacity="0.85"
            stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round"/>
      <path d="M22 8 C16 14 12 20 9.5 25.5"
            stroke="white" strokeWidth="1.6" strokeLinecap="round" fill="none" opacity="0.9"/>
    </svg>
  );
}
export function IconCity(p = {}) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <rect x="2" y="8" width="9" height="12" rx="1"/>
      <rect x="13" y="3" width="9" height="17" rx="1"/>
      <line x1="5" y1="12" x2="5" y2="12"/><line x1="5" y1="16" x2="5" y2="16"/>
      <line x1="8" y1="12" x2="8" y2="12"/><line x1="8" y1="16" x2="8" y2="16"/>
      <line x1="16" y1="7" x2="16" y2="7"/><line x1="19" y1="7" x2="19" y2="7"/>
      <line x1="16" y1="11" x2="16" y2="11"/><line x1="19" y1="11" x2="19" y2="11"/>
      <line x1="16" y1="15" x2="16" y2="15"/><line x1="19" y1="15" x2="19" y2="15"/>
    </svg>
  );
}
export function IconArrow(p = {}) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" {...p}>
      <line x1="5" y1="12" x2="19" y2="12"/>
      <polyline points="12 5 19 12 12 19"/>
    </svg>
  );
}
export function IconStar(p = {}) {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" {...p}>
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  );
}

